import {
  Button, Form, Input, Modal, message,
} from 'antd';
import { topics } from '@/api';
import React, { useState, useEffect } from 'react';
import useTopicGroups from '@/components/discovery/hooks/useTopicGroups';
import SelectCustomDropdown from '@/base-components/topic-modal/components/SelectCustomDropdown';
import { displayOrCatchMessage } from '@/helpers';
import { useHistory } from 'react-router-dom';

export default function DuplicateModal({
  children, visible, setVisible, topic, topicId, ...props
}) {
  const history = useHistory();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const {
    data, isLoading, error, isError,
  } = useTopicGroups();

  useEffect(() => {
    if (isError) {
      message.error(error.message, 1.5);
    }
  }, [error]);

  const onCreate = (values) => {
    setLoading(true);
    topics.duplicateTopic({
      topic_id: topicId,
      name: values.name,
      groups: [values.groups],
    }).then((response) => {
      const newTopic = response.data.data;
      history.push(`/topic/overview/${newTopic.id}/${newTopic.groups[0].id}`);
      setVisible(false);
    }).catch((e) => {
      setLoading(false);
      displayOrCatchMessage(e);
    });
  };

  return (
    <Modal
      title="Duplicate Segment"
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <Button
          key="submit"
          type="primary"
          loading={loading}
          disabled={loading}
          onClick={() => {
            form.validateFields().then((values) => {
              onCreate(values);
            });
          }}
        >
          Save
        </Button>,
      ]}
      {...props}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        className="space-y-4"
      >
        <Form.Item
          name="name"
          rules={[{ required: true, message: 'Name is required' }]}
          className="group"
          label={<span className="text-grey-700 font-[Gordita-Regular]">Name</span>}
          initialValue={topic ? `${topic} - duplicate` : undefined}
        >
          <Input
            className="!rounded-md !border-[#CFDBE4] !px-3.5 !py-1.5 focus:!ring-[#0CAA6B1A] [&_.ant-input]:!text-[#202324] [&_.ant-input]:!text-sm focus:!border-[#74899B] focus:!ring [&_.ant-input]:placeholder:font-[Gordita-Regular] [&_.ant-input]:placeholder:!text-[#74899B] group-[.ant-form-item-has-error]:!border-[#F17C99]"
            allowClear
            placeholder="Name"
            size="large"
          />
        </Form.Item>
        <Form.Item
          name="groups"
          rules={[{ required: true, message: 'Category is required' }]}
          label={<span className="text-grey-700 font-[Gordita-Regular]">Category</span>}
        >
          <SelectCustomDropdown
            disabled={isLoading}
            loading={isLoading}
            size="large"
            valueProp="name"
            textProp="name"
            placeholder="Category"
            newOptionBtnText="Create new category"
            options={data?.map(({ name: groupName, id, color }) => ({
              name: groupName,
              id,
              color,
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
